import React from 'react';
import { Offline, Online } from 'react-detect-offline';

// motivation: allow for testing offline
export const NSOnline = ({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element => {
  console.log('ENV', process.env.NODE_ENV);
  if (process.env.NODE_ENV === 'development') {
    return <>{children}</>;
  } else {
    return <Online>{children}</Online>;
  }
};
export const NSOffline = ({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element | null => {
  if (process.env.NODE_ENV === 'development') {
    return null;
  } else {
    return <Offline>{children}</Offline>;
  }
};
